import { useEffect, useState } from "react"
import { RiMenu3Line } from "react-icons/ri"
import { Box, HStack, IconButton, Spacer, Stack } from "@chakra-ui/react"
import { ALL_STEPS } from "@/constants"
import { Deal, StepDetail } from "@/types"
import { WhatsNextModal } from "../modals"
import { Button, PulsingDot, Text } from "../ui"

interface Props {
  deals: Deal[]
  currentDeal: Deal | null
  onDealChange: (deal: Deal) => void
  onOpenDrawer?: () => void
}

export const ViewAsNavBar = ({ deals, currentDeal, onDealChange, onOpenDrawer }: Props) => {
  const [isWhatsNextOpen, setIsWhatsNextOpen] = useState(false)
  const [currentStepDetail, setCurrentStepDetail] = useState<StepDetail | null>(null)
  const hasActiveDeal = deals.some(d => d.isActive === 1)

  useEffect(() => {
    if (currentDeal && currentDeal.isActive === 1) {
      const index = ALL_STEPS.findIndex(step => step.step === currentDeal.currentStep)
      setCurrentStepDetail(index !== -1 ? ALL_STEPS[index] : null)
    } else {
      setCurrentStepDetail(null)
    }
  }, [currentDeal])

  return (
    <HStack pt={2} pb={2} pr={{ base: 3, md: 5 }} bg="white" w="100%" minH="56px" borderBottom="1px solid" borderColor="gray.200">
      {onOpenDrawer && (
        <IconButton
          aria-label="Open menu"
          variant="ghost"
          size="sm"
          ml={2}
          onClick={onOpenDrawer}
        >
          <RiMenu3Line size={22} />
        </IconButton>
      )}
      <Box display={{ base: "none", md: "flex" }} flex={1} minW={0}>
        <Stack gap={0} mx={5} cursor={hasActiveDeal ? "pointer" : "default"} onClick={hasActiveDeal ? () => setIsWhatsNextOpen(true) : undefined}>
          <HStack>
            <Text fontSize="md" fontWeight="bold" lineClamp={1}>{currentStepDetail ? currentStepDetail.title : "No Active Step"}</Text>
            {hasActiveDeal && <PulsingDot />}
          </HStack>
          <Text fontSize="xs" color="gray.500" lineClamp={1}>{currentStepDetail ? currentStepDetail.description : "No active steps at the moment. Please reach out to your Equity Partner if you have any questions."}</Text>
        </Stack>
      </Box>
      <Spacer />
      {deals && deals.length > 0 && hasActiveDeal && (
        <Button variant="solid" size={{ base: "sm", md: "md" }} mr={{ base: 2, md: 5 }} onClick={() => setIsWhatsNextOpen(true)}>
          What's Next?
        </Button>
      )}
      {hasActiveDeal && <WhatsNextModal deals={deals} currentDeal={currentDeal} onDealChange={onDealChange} isOpen={isWhatsNextOpen} onClose={() => setIsWhatsNextOpen(false)} />}
    </HStack>
  )
}
